module.exports = __webpack_public_path__ + "static/media/FloorScrape1_After.d3a40442.jpg";